export const selected3dMapAction = selectedTab => ({
    type: 'SELECTED_3DMAP',
})

export const unselected3dMapAction = selectedTab => ({
    type: 'UNSELECTED_3DMAP',
})